module.exports = __webpack_public_path__ + "img/black-setting-icon.638550ca.svg";